export default __webpack_public_path__ + "static/media/fsync2.92ca980b.png";